import React, { useState, useEffect } from "react";
import { isMobileOrTablet } from "../../Views/MobileClassRenderer";

function MuteSVG() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16699 4.16663L5.00033 7.49996H1.66699V12.5H5.00033L9.16699 15.8333V4.16663Z"
        stroke="#a8a8a8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.167 7.5L14.167 12.5"
        stroke="#a8a8a8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.167 7.5L19.167 12.5"
        stroke="#a8a8a8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default function ButtonClickToUnmute() {
  const ANIM_DURATION = 250;
  const HIDE_AFTER = 2500;
  // const HIDE_AFTER = 100000000
  const [show, setShow] = useState(false);
  const [mounted, setMounted] = useState(true);
  const [hideTimeout, setHideTimeout] = useState(null);
  const [hideImmediate, setHideImmediate] = useState(false);

  function handleHide() {
    if (hideTimeout) clearTimeout(hideTimeout);
    const timeout = setTimeout(hide, ANIM_DURATION);
    setHideTimeout(timeout);
  }

  function handleHideImmediate() {
    setHideImmediate(true);
  }

  function hide() {
    setShow(false);
    setMounted(false);
  }

  useEffect(() => {
    setShow(true);
    const timeout = setTimeout(handleHide, HIDE_AFTER);
    setHideTimeout(timeout);

    return () => {
      if (hideTimeout) clearTimeout(hideTimeout);
    };
  }, []);

  return (
    <>
      {mounted && (
        <div
          className={`btn-click-to-unmute rounded ${show ? "" : "hidden"} ${
            hideImmediate ? "hidden--immediate" : ""
          } ${isMobileOrTablet() ? "mobile" : ""}`}
          onMouseEnter={handleHideImmediate}
        >
          <div className="btn-click-to-unmute__icon">
            <MuteSVG />
          </div>
          <p className="btn-click-to-unmute__text">
            {isMobileOrTablet() ? "Tap" : "Click"} to Unmute/Mute
          </p>
        </div>
      )}
    </>
  );
}
